import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Global from '../../../../store/global-selectors';
import messages from '../messages';
import { emptyArray } from 'ui-components/default-props/empty';

const InternationalConfirmationColumn = ({ id: presetGroupId }) => {
  const internationalConfirmationId = useSelector((state) =>
    Global.selectEntitiesPresetGroupPropertyById(state, {
      profileId: presetGroupId,
      property: 'intlConfirmationId',
    }),
  );
  const serviceId = useSelector((state) =>
    Global.selectEntitiesPresetGroupPropertyById(state, {
      profileId: presetGroupId,
      property: 'serviceId',
    }),
  );
  const internationalService = useSelector((state) => Global.selectSellerServiceById(state, { serviceId }));
  const carriers = useSelector((state) => Global.selectReferenceDatagetSellerCarriers(state));

  const carrierId = internationalService?.carrierId;
  const selectedCarrier = carriers.find((carrier) => carrier.carrierId === carrierId);
  const carrierConfirmations = selectedCarrier?.confirmations || emptyArray;
  const selectedConfirmation = carrierConfirmations.find((type) => type.confirmationId === internationalConfirmationId);
  const confirmationDisplayText = selectedConfirmation?.name;

  return confirmationDisplayText;
};

InternationalConfirmationColumn.propTypes = {
  id: PropTypes.string.isRequired,
};

export default {
  getMessageDescriptor: messages.internationalConfirmationColumn,
  name: <FormattedMessage {...messages.internationalConfirmationColumn} />,
  id: 'internationalConfirmation',
  isSortable: false,
  render: InternationalConfirmationColumn,
};
